import { Theme } from '@mui/material';
import { SxProps } from '@mui/system';
import ThemeConstants from '../../../../theme/ThemeConstants';

const separatorSelector = '& > :not(:last-child)::after';
const separatorVerticalInset = '4px';

const styles = {
  container: {
    padding: '4px',
  },

  itemsContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: '8px',
    [separatorSelector]: {
      content: '""',
      position: 'absolute',
      top: separatorVerticalInset,
      bottom: separatorVerticalInset,
      right: '-4px',
      width: '1px',
      backgroundColor: ThemeConstants.common.error,
    },
  },

  verticalItemsContainer: {
    flexDirection: 'column',
    gap: '4px',
    [separatorSelector]: {
      top: 'auto',
      bottom: '-2px',
      left: 0,
      right: 0,
      width: 'auto',
      height: '1px',
    },
  },
} satisfies Record<string, SxProps<Theme>>;

export default styles;
